import { render } from "./ProjectItemSlide.vue?vue&type=template&id=c721c7d0&scoped=true"
import script from "./ProjectItemSlide.vue?vue&type=script&lang=js"
export * from "./ProjectItemSlide.vue?vue&type=script&lang=js"

import "./ProjectItemSlide.vue?vue&type=style&index=0&id=c721c7d0&lang=scss&scoped=true"

import exportComponent from "/home/mmelillo/development/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c721c7d0"]])

export default __exports__